<template>
  <div class="con3">
    <div class="container">
      <p class="text-title">
        의사소통 중심<span>(*CLT기반)</span>의<br />완벽 학습 설계
      </p>
      <div class="m-slide">
        <VueSlickCarousel ref="carousel" v-bind="settings">
          <div class="item">
            <img src="@/assets/img/aitutorplus/con3/img0-m.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/img/aitutorplus/con3/img1-m.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/img/aitutorplus/con3/img2-m.png" alt="" />
          </div>
        </VueSlickCarousel>
      </div>
      <ul class="pc-content">
        <li>
          <div>
            <p>1단계</p>
            <p>사전학습</p>
            <img src="@/assets/img/aitutorplus/con3/img0.png" alt="" />
          </div>
          <p>
            <span>3분으로 마스터</span>하는 오늘의 핵심표현!<br />1-Bite English
          </p>
        </li>
        <li>
          <div>
            <p>2단계</p>
            <p>연습대화</p>
            <img src="@/assets/img/aitutorplus/con3/img1.png" alt="" />
          </div>
          <p>
            <span>주제별 예시 대화</span>를 통한<br />AI와의 상황 대화 훈련!
          </p>
        </li>
        <li>
          <div>
            <p>3단계</p>
            <p>실전대화</p>
            <img src="@/assets/img/aitutorplus/con3/img2.png" alt="" />
          </div>
          <p><span>말랑톡과의 실전 훈련</span>으로<br />자연스러운 상황 경험</p>
        </li>
      </ul>
      <p class="what-clt">
        <span>*CLT란?</span><br />Communicative Language Teaching의 약어로<br
          class="br-m"
        />
        의사소통 경험을 통해 실제 상황에서 사용할 수 있도록<br class="br-m" />
        유창성을 증진시키는 의사소통 중심 교수법
      </p>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        initialSlide: 0,
        centerMode: true,
        swipeToSlide: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        cssEase: "ease-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con3 {
  padding: 86px 0;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title {
    font-size: 30px;
    font-weight: 700;
    color: #18181b;
    text-align: center;
    margin-bottom: 46px;

    span {
      font-size: 15px;
      font-weight: 400;
    }

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      margin-bottom: 82px;

      span {
        font-size: 30px;
      }
    }
  }

  .m-slide {
    margin-bottom: 30px;

    @media screen and (min-width: 1200px) {
      display: none;
    }

    :deep(.slick-slider) {
      .slick-list {
        .slick-track {
          .slick-slide {
            padding: 0 10px;

            > div {
              .item {
                img {
                  max-width: 295px;
                  margin: 0 auto;
                }
              }
            }
          }
        }
      }
    }
  }

  .pc-content {
    display: none;

    @media screen and (min-width: 1200px) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 26px;
      margin-bottom: 64px;
    }

    li {
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 48px 70px;
        background-color: #f3f4f6;
        border-radius: 26px;
        margin-bottom: 28px;

        > p {
          text-align: center;

          &:nth-of-type(1) {
            display: inline-block;
            font-size: 17px;
            font-weight: 500;
            color: #fff;
            padding: 8px 24px;
            background-color: #8b5cf6;
            border-radius: 24px;
            margin-bottom: 10px;
          }

          &:nth-of-type(2) {
            font-size: 30px;
            font-weight: 700;
            color: #18181b;
            margin-bottom: 18px;
          }
        }
      }

      > p {
        font-size: 20px;
        color: #18181b;
        text-align: center;
        line-height: 31px;

        span {
          font-weight: 700;
        }
      }
    }
  }

  .what-clt {
    font-size: 13px;
    color: #6b7280;
    text-align: center;
    line-height: 22px;

    span {
      font-weight: 700;
    }

    @media screen and (min-width: 1200px) {
      text-align: left;
    }
  }
}
</style>
